const STATUS_PROOF_NEEDED = "Proof Needed";
const STATUS_UPLOADED = "Uploaded";

// This readiness checkbox owns only the Proof Needed <-> Uploaded transition.
// Customer approval and other later lifecycle statuses must remain authoritative.
export const getProofStatusForReadiness = (proofStatus, checked) => {
  const currentStatus = proofStatus || STATUS_PROOF_NEEDED;

  if (checked && currentStatus === STATUS_PROOF_NEEDED) {
    return STATUS_UPLOADED;
  }
  if (!checked && currentStatus === STATUS_UPLOADED) {
    return STATUS_PROOF_NEEDED;
  }
  return currentStatus;
};

export const buildProofReadinessPatch = (proof, checked) => ({
  allProofsUploaded: checked,
  proofStatus: getProofStatusForReadiness(proof?.proofStatus, checked),
});
